import { useState, useEffect, useMemo } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import MapCanvas from "../../components/MapCanvas/MapCanvas";
import TopToolbar from "../../components/TopToolbar/TopToolbar";
import useProjects from "../../hooks/projects/useProjects";
import useOrgHierarchy from "../../hooks/projects/useOrgHierarchy";
import { projectMatchesZone, safeEquals } from "../../utils/orgFilters";
import "./GISWorkspace.css";

function GISWorkspace() {
  const [filters, setFilters] = useState({
    zone: null,
    circle: null,
    district: null,
    taluka: null,
    village: null,
    landType: null,
    status: null,
  });

  const { projects, loading, fetchProjects } = useProjects();
  const { zonesList, circlesList, districtsList, talukasList, loading: hierarchyLoading } = useOrgHierarchy();

  const [selectedProject, setSelectedProject] = useState(null);

  // Fetch ALL projects once when component mounts
  useEffect(() => {
    fetchProjects({ 
      pagination: "false" 
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);   // ← Empty dependency array (intentional)

  const filteredProjects = useMemo(() => {
    return projects.filter((project) => {
      if (!projectMatchesZone(project, filters.zone, zonesList)) return false;
      if (!safeEquals(project.circle_name, filters.circle)) return false;
      if (!safeEquals(project.district_name, filters.district)) return false;
      if (!safeEquals(project.taluka_name, filters.taluka)) return false;
      if (!safeEquals(project.village, filters.village)) return false;
      if (!safeEquals(project.land_type, filters.landType)) return false;
      if (!safeEquals(project.status, filters.status)) return false;

      return true;
    });
  }, [projects, filters, zonesList]);

  return (
    <div className="gis-page">
      <PageHeader>
        <TopToolbar
          projects={projects}
          filters={filters}
          setFilters={setFilters}
          onProjectSelect={setSelectedProject}
          zonesList={zonesList}
          circlesList={circlesList}
          districtsList={districtsList}
          talukasList={talukasList}
          hierarchyLoading={hierarchyLoading}
        />
      </PageHeader>

      <MapCanvas
        projects={filteredProjects}
        loading={loading}
        selectedProject={selectedProject}
      />
    </div>
  );
}

export default GISWorkspace;